export default function isElementInView (element) {
  const pageTop = window.scrollY
  const pageBottom = pageTop + window.innerHeight
  const {
    top: elementTop,
    // bottom: elementBottom,
  } = element.getBoundingClientRect()
  return (elementTop <= pageBottom) // && (elementBottom >= pageTop)
}